"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createWorkflows = exports.CreateWorkflows = exports.CreateWorkflowsActionTypes = exports.fetchWorkflows = exports.FetchWorkflows = exports.FetchWorkflowsActionTypes = exports.deleteWorkflows = exports.DeleteWorkflows = exports.DeleteWorkflowsActionTypes = exports.QuoteAutomationActionTypes = void 0;

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var _actions = require("settings-ui-lib/utils/actions");

var _fluxActions = require("flux-actions");

var QuoteAutomationActionTypes = (0, _namespacedKeyMirror.default)({
  FETCH_WORKFLOWS: null,
  DELETE_WORKFLOWS: null,
  CREATE_WORKFLOWS: null
}, 'quoteAutomation');
exports.QuoteAutomationActionTypes = QuoteAutomationActionTypes;
var DeleteWorkflowsActionTypes = (0, _actions.createRequestTypes)(QuoteAutomationActionTypes.DELETE_WORKFLOWS);
exports.DeleteWorkflowsActionTypes = DeleteWorkflowsActionTypes;
var DeleteWorkflows = (0, _actions.createRequestActions)(DeleteWorkflowsActionTypes);
exports.DeleteWorkflows = DeleteWorkflows;
var deleteWorkflows = (0, _fluxActions.createAction)(QuoteAutomationActionTypes.DELETE_WORKFLOWS);
exports.deleteWorkflows = deleteWorkflows;
var FetchWorkflowsActionTypes = (0, _actions.createRequestTypes)(QuoteAutomationActionTypes.FETCH_WORKFLOWS);
exports.FetchWorkflowsActionTypes = FetchWorkflowsActionTypes;
var FetchWorkflows = (0, _actions.createRequestActions)(FetchWorkflowsActionTypes);
exports.FetchWorkflows = FetchWorkflows;
var fetchWorkflows = (0, _fluxActions.createAction)(QuoteAutomationActionTypes.FETCH_WORKFLOWS);
exports.fetchWorkflows = fetchWorkflows;
var CreateWorkflowsActionTypes = (0, _actions.createRequestTypes)(QuoteAutomationActionTypes.CREATE_WORKFLOWS);
exports.CreateWorkflowsActionTypes = CreateWorkflowsActionTypes;
var CreateWorkflows = (0, _actions.createRequestActions)(CreateWorkflowsActionTypes);
exports.CreateWorkflows = CreateWorkflows;
var createWorkflows = (0, _fluxActions.createAction)(QuoteAutomationActionTypes.CREATE_WORKFLOWS, function (approverOwnerId) {
  return approverOwnerId;
});
exports.createWorkflows = createWorkflows;